export const GET_CYCLES_LIST = "GET_CYCLES_LIST";
export const GET_CYCLES_LIST_FULFILLED = "GET_CYCLES_LIST_FULFILLED";
export const GET_CYCLES_LIST_REJECTED = "GET_CYCLES_LIST_REJECTED";
